<template>
  <v-app>
    <v-progress-linear v-if="loading" absolute color="primary" indeterminate />
    <v-main>
      <div class="logo-header-wrapper">
        <div class="ia-logo">
          <IAIcon/>
        </div>
        <div class="ia-header-title">
          <span>iAnnotate for Intune</span>
        </div>
      </div>
      <div class="container">
        <div class="justify-center">
          <button class="sign-in-button" @click="onClickSignIn">Login</button>
          <button class="sign-in-button" @click="onClickSignUp">Create Account</button>
          <button class="sign-out-button" @click="onClickSignOut">Log out</button>
        </div>
      </div>
      <div class="text-version">{{ version }}</div>
    </v-main>
  </v-app>
</template>

<script>
import IAIcon from "../../assets/icons/IAIcon.vue"
import {isMobileMixin} from "@/mixins";
import {mapState} from "vuex";
import router from "@/router";

export default {
  name: "Auth",
  mixins: [isMobileMixin],
  components: { IAIcon },
  data() {
    return {}
  },

  computed: {
    ...mapState(['loading', 'version']),
  },
  methods: {
    onClickSignIn() {
      this.$auth0.signIn()
        .then(() => router.replace("/"))
        .catch(console.error);
    },
    onClickSignUp() {
      this.$auth0.signUp()
        .then(() => router.replace("/"))
        .catch(console.error);
    },
    onClickSignOut() {
      this.$auth0.signOut();
    }
  }
}
</script>

<style scoped>
  .container {
    position: relative;
    display: flex;
    height: 50vh;
    align-items: center;
    justify-content: center;
  }

  /* .logo {
    position: absolute;
    width: 50px;
    height: 50px;
    left: 10px;
    top: 10px;
    border-radius: 4px;
    background: url("../../assets/images/IAnnotateLogoIcon.png")no-repeat;
  } */
  .logo-header-wrapper {
    width: 100%;
    display:flex;
    flex-direction: column;
    align-items: center;
    height: 280px;
    background: rgba(197, 200, 202, 0.2);
    margin-bottom: 10px;
  }
  .ia-logo {
    margin-top:60px;
  }
  .ia-header-title {
    margin-top: 30px;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
    text-align: center;
    color: #18181E;
  }

  .text-version {
    position: absolute;
    right: 20px;
    bottom: 20px;
    color: gray;
  }

  .justify-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }

  .sign-in-button {
    background: rgba(197, 200, 202, 0.2);
    padding: 5px 15px;
    min-width: 150px;
    border-radius: 20px;
    box-shadow: 2px 2px 10px silver;

    &:active {
      transform: translate(1px, 1px);
    }
  }
  .sign-out-button {
    display: none;
    border: none;
    outline: none;
    background: transparent;
    padding: 5px 15px;
    min-width: 150px;
    border-radius: 5px;
    color: dodgerblue;
    cursor: pointer;
  }
</style>